import { useState, useEffect } from 'react'
import { useNewsStore } from '../stores/newsStore'

/**
 * Hook for managing keyword registration and validation
 * Handles registered keywords, errors, and sync with store
 */
/** Shown to a first-time visitor who has nothing persisted yet. */
export const DEFAULT_KEYWORDS = ['정치', '경제', '사회']

export function useKeywordManagement() {
  const [searchErrors, setSearchErrors] = useState<string[]>([])
  // Restore what the user was tracking. `keywords` is persisted (newsStore
  // partialize), and zustand rehydrates localStorage synchronously, so the stored
  // value is already available on first render.
  const [registeredKeywords, setRegisteredKeywords] = useState<string[]>(() => {
    const persisted = useNewsStore.getState().keywords
    return persisted.length > 0 ? persisted : DEFAULT_KEYWORDS
  })

  const { keywords: storeKeywords, setKeywords: setStoreKeywords } = useNewsStore()

  // Sync registered keywords to store
  useEffect(() => {
    if (registeredKeywords.length > 0 && registeredKeywords.join(',') !== storeKeywords.join(',')) {
      setStoreKeywords(registeredKeywords)
    }
  }, [registeredKeywords, storeKeywords, setStoreKeywords])

  const handleRegisteredKeywordsChange = (keywords: string[]) => {
    setRegisteredKeywords(keywords)
    setSearchErrors([]) // Clear errors when keywords change
  }

  const clearErrors = () => {
    setSearchErrors([])
  }

  const addError = (error: string) => {
    setSearchErrors((prev) => [...prev, error])
  }

  const validateKeywords = (): boolean => {
    if (registeredKeywords.length === 0) {
      setSearchErrors(['최소 1개 이상의 키워드를 등록해주세요.'])
      return false
    }
    return true
  }

  return {
    registeredKeywords,
    searchErrors,
    setRegisteredKeywords,
    handleRegisteredKeywordsChange,
    clearErrors,
    addError,
    validateKeywords,
  }
}
